import { render, staticRenderFns } from "./profileOrders.vue?vue&type=template&id=691ca504&scoped=true"
import script from "./profileOrders.vue?vue&type=script&lang=js"
export * from "./profileOrders.vue?vue&type=script&lang=js"
import style0 from "./profileOrders.vue?vue&type=style&index=0&id=691ca504&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691ca504",
  null
  
)

export default component.exports